import { render, staticRenderFns } from "./btn-top-secondary.vue?vue&type=template&id=3cfb4562&scoped=true"
import script from "./btn-top-secondary.vue?vue&type=script&lang=js"
export * from "./btn-top-secondary.vue?vue&type=script&lang=js"
import style0 from "./btn-top-secondary.vue?vue&type=style&index=0&id=3cfb4562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfb4562",
  null
  
)

export default component.exports